import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class FlutterMessagesService {
  private router = inject(Router);

  init() {
    window.addEventListener('message', (event: MessageEvent) => {
      if (event.data?.type === 'flutter_navigation') {
        this.router.navigate([event.data.url]);
      }
    });
  }
}
